module.exports = __webpack_public_path__ + "static/media/instagram.1181461c.svg";